<template>
<div class="error">
  <div class="error-bg" ref="contBg">
    <div data-dimension>404 </div>
  </div>

  <div class="link-cont">
    <p>Fly to another city:</p>
    <h3>
      <router-link
        data-mouse
        data-mouse-attractionState="disactive"
        data-hover-type="fadeout"
        :to="`/${city}`"
      >
        {{ city }}
      </router-link>
    </h3>
  </div>
</div>
</template>

<script>
import { setInterval } from 'timers';

import Error from '@/scripts/error';
import { getRandom } from '@/scripts/utils';

export default {
  name: 'ErrorPage',

  data() {
    return {
      cityList: [
        'tokyo',
        'porto',
        'berlin',
        'milan',
      ],
      city: 'tokyo',
    };
  },

  mounted() {
    this.$store.commit('ADD_BUTTONS', this.$el);

    this.error = new Error(this.$refs.contBg);
    this.error.init();

    setInterval(() => {
      this.city = this.changeCity();
    }, 5000);
  },

  methods: {
    changeCity() {
      const number = getRandom(0, (this.cityList.length - 1));
      return this.cityList[number];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';

:global {
  @keyframes moveLine {
    0% {
      transform: rotateZ(-45deg) translateX(3%);
    }
    100% {
      transform: rotateZ(-45deg) translateX(-3%);
    }
  }
}

.error {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .link-cont {
    position: absolute;
    top: 50%;
    left: 20%;

    p {
      margin: 0;
      padding: 0;

      font-family: 'Neutral';
      font-size: 1rem;
      font-weight: 400;
      font-style: italic;
      color: $color-dark-gray;
    }

    h3 a {
      padding: 0;
      margin: 0;

      font-family: 'Neutral';
      font-size: 2.25rem;
      font-weight: 500;
      color: $color-light;
      text-transform: capitalize;

      &:hover {
        color: $color-blue;
      }
    }
  }
}

.error-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  font-family: 'Neutral';
  font-size: 9rem;
  font-weight: 500;
  color: transparent;
  -webkit-text-stroke: 2px #1217ff;

  overflow: hidden;

  [data-dimension] {
    display: inline-block;
    position: absolute;
    margin: 0;

    white-space: nowrap;

    opacity: 0;
  }

  :global(.error-text) {
    display: inline-block;
    position: absolute;
    margin: 0;

    white-space: nowrap;
    font-family: 'Neutral';
    font-size: 9rem;
    font-weight: 500;
    color: transparent;
    -webkit-text-stroke: 2px $color-blue;

    transform-origin: 0 100%;
    animation: moveLine 1.8s ease-in-out 0s infinite alternate forwards;
    backface-visibility: hidden;
    transform-style: preserve-3d;

    will-change: transform;

    &:hover {
      color: $color-blue;
    }

    &:nth-child(even) {
      animation: moveLine 1.8s ease-in-out 0s infinite alternate-reverse forwards;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/404.vue